export default __webpack_public_path__ + "7222002afdbf41e14f23a664e7229b83.svg";